export default __webpack_public_path__ + "static/media/hoodie.f6d63918.png";